const CONSUMPTION_TYPE = {
    POWER: 'POWER',
    HYBRID: 'HYBRID',
    FUEL: 'FUEL',
}

const CONSUMPTION_UNIT = {
    CO2: 'g/km',
    VEHICLE_WEIGHT: 'kg',
    RANGE: 'km',
    FUEL: 'l/100km',
    POWER: 'kWh/100km',
}

const FUEL_TYPE = {
    PETROL: 'PETROL',
    DIESEL: 'DIESEL'
}

const EFFICIENCY_CLASS = {
    'A+': 'A+',
    'A': 'A',
    'B': 'B',
    'C': 'C',
    'D': 'D',
    'E': 'E',
    'F': 'F',
    'G': 'G',
    '-': '-'
}

exports = module.exports = {
    CONSUMPTION_TYPE,
    CONSUMPTION_UNIT,
    FUEL_TYPE,
    EFFICIENCY_CLASS
}